import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row } from 'react-bootstrap';

import Book from './Book';
import { getServerBookUrl } from '../../util/util';
import Chatbot from '../../component/Chatbot';
import { useSelector } from 'react-redux';

const BookView = (props) => {
  const params = useParams();
  const user = useSelector((state) => state.userReducer);
  const bookUrl = getServerBookUrl(
    params.bookParent,
    params.language,
    params.bookName,
    params.pageType,
    params.pageNo
  );

  return (
    <Container>
      <Row>
        <Book bookUrl={bookUrl} />
      </Row>
      {window.innerWidth > 768 && <Chatbot />}
    </Container>
  );
};

export default BookView;
